import { render, staticRenderFns } from "./adminLevels.vue?vue&type=template&id=1b648775"
import script from "./adminLevels.vue?vue&type=script&lang=js"
export * from "./adminLevels.vue?vue&type=script&lang=js"
import style0 from "./adminLevels.vue?vue&type=style&index=0&id=1b648775&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports